/**
 * Returns "<count> <singular|plural>", picking the singular form when count is 1.
 *
 * @example pluralize(1, 'time', 'times') // "1 time"
 * @example pluralize(3, 'day', 'days')   // "3 days"
 */
export const pluralize = (count: number, singular: string, plural: string) =>
  `${count} ${count === 1 ? singular : plural}`;
